import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import ProductControl from '@/blocks.04-project/product-control/product-control';

/***
 * Класс карточек товара в подарочном наборе
 * @example
 */
class GiftSetCard extends ProductControl {
	/***
	 * Конструктор класса
	 * @param selector {String} селектор для поиска блока
	 * @param options {Object} данные карточки
	 * @param elem {HTMLElement|undefined} элемент для инициализации
	 */
	constructor({ selector, options, elem }) {
		super({ blockClass: 'gift-set-card', selector, options, elem });
		this.BlockError = new BlockError({ blockName: 'GiftSetCard', destroy: this.destroy });
		this.block.GiftSetCard = this;
		this.block.AsyncGiftSetCard = new Promise((resolve) => {
			this.promiseResolve = resolve;
		}).then((ins) => ins);

		this.LazyInit = new LazyInit({ ins: this, callback: this.init.bind(this), addClass: 'gift-set-card_inited' });
		if (!this.bh) {
			window.getBH((bh) => {
				this.bh = bh;
				this.LazyInit.init();
			});
		} else {
			this.LazyInit.init();
		}
	}

	async init() {
		await super.init();
		this.promiseResolve(this);
		this.block.AsyncGiftSetCard = this;
	}
	render() {
		super.render();
	}

	destroy() {
		super.destroy();
		if (this.LazyInit) this.LazyInit.destroy();
		if (this.block) {
			this.block.classList.remove('gift-set-card_inited');
			delete this.block.GiftSetCard;
			delete this.block.AsyncGiftSetCard;
		}
	}
}

if (NOT_PROD) {
	const options = {
		data: {
			'id': 25625,
			'currentOfferId': 24610,
			'title': 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
			'description': '',
			'vat': 'с НДС',
			'colors': [],
			'languages': [],
			'offers': [
				{
					'id': 24610,
					'name': 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
					'article': '69698',
					'photos': [
						{
							src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
							alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
						},
					],
					'margin': null,
					'price': '6&nbsp;690 &#8381;',
					'priceValue': 6690,
					'oldPrice': '7900',
					'quantity': 898,
					'color': null,
					'lang': null,
					'status': {
						'code': 'IN_STOCK',
						'text': 'В наличии'
					},
					'badges': [],
					'sale': null,
					'sales': [],
					'gifts': []
				}
			],
			'priceOnRequest': false,
			'priceRequestFormId': null,
			'photos': [],
		}
	};
	Array.from(document.querySelectorAll('.gift-set-card:not(.gift-set-card_inited)')).forEach((elem) => {
		new GiftSetCard({
			elem, options
		});
	});
}


// Экспорт;
window.Block.GiftSetCard = GiftSetCard;
